import { inject, singleton } from "tsyringe";
import { NAVIGATOR } from "@identity/symbols";
import { Platform, Platforms } from "./platform";

export type DeviceType = "smartphone" | "desktop";

@singleton()
export class Device {
  private readonly testRegex =
    /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  private readonly userAgent: string;

  constructor(
    @inject(NAVIGATOR) navigator: Navigator,
    @inject(Platform) private readonly platform: Platform,
  ) {
    this.userAgent = navigator.userAgent;
  }

  public getDeviceType(): DeviceType {
    const platform = this.platform.get();

    if (platform === Platforms.FANDOMDESKTOP) {
      return "desktop";
    }

    if (platform === Platforms.FANDOMMOBILE) {
      return "smartphone";
    }

    return this.testRegex.test(this.userAgent) ? "smartphone" : "desktop";
  }
}
